export const iconFontAwesomeDevicesHardwareCamera = (
	<i className="fa-solid fa-camera"></i>
);
